import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateTableHeader = () => {
  return (
    <tr
      id="report-column-header"
      className={`row-start-start ${tableWidth} text-sm bg-zinc-100 font-semibold text-slate-800 `}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border  px-2 h-full pb-2 pt-3 `}
      >
        {settings["no"].name}
      </td>

      <td
        className={`${settings["tanggal"].layout} ${settings["tanggal"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["tanggal"].name}
      </td>

      <td
        className={`${settings["durasi"].layout} ${settings["durasi"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["durasi"].name}
      </td>

      <td
        className={`${settings["label_grup"].layout} ${settings["label_grup"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["label_grup"].name}
      </td>

      <td
        className={`${settings["keterangan"].layout} ${settings["keterangan"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["keterangan"].name}
      </td>
    </tr>
  );
};

export default ReportTemplateTableHeader;
